import { Injectable } from "@angular/core";
@Injectable()
export class QueueStatus {
    UNSYNCED = 0;
    PROCESSING = 1;
    SUCCESS = 2;
    FAILURE = 3;
}
